// extracted by mini-css-extract-plugin
export default {"header__content":"styles_header__content__RI6IY","content":"styles_content__kHQrS","content__card":"styles_content__card__sFzhp"};